import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface SIMCreditAlarmProps {
  alarm: {
    type: string;
    credit_Threshold: number;
  };
  onChange: (updatedAlarm: SIMCreditAlarmProps['alarm']) => void;
}

const SIMCreditAlarm: FC<SIMCreditAlarmProps> = ({ alarm, onChange }) => {
  const [threshold, setThreshold] = useState<number>(alarm.credit_Threshold);

  useEffect(() => {
    setThreshold(alarm.credit_Threshold);
  }, [alarm.credit_Threshold]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    setThreshold(value);
    onChange({ ...alarm, credit_Threshold: value });
  };

  return (
    <div className="form-group col-md-4 col-sm-4">
      <label htmlFor="simCredit">Seuil de crédit SIM (DZD) :</label>
      <div className="input-group">
        <span
          className="input-group-addon"
          style={{
            backgroundColor: '#ff7e41',
            color: 'white',
            width: '40px',
            textAlign: 'center'
          }}
        >
          <i className="fa fa-sim-card" />
        </span>
        <input
          type="number"
          min={0}
          step={1}
          className="form-control input-sm"
          id="simCredit"
          name="credit_threshold"
          value={threshold}
          onChange={handleThresholdChange}
          placeholder="Ex : 200 DZD"
        />
        <span className="input-group-addon">DZD</span>
      </div>
    </div>
  );
};

export default SIMCreditAlarm;
